import { Component, OnInit, Input, ViewEncapsulation, ViewChild, ElementRef, TemplateRef, Output,  SimpleChanges, OnChanges, EventEmitter } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CoordinatesService, TransformationType, Direction} from 'angular-coordinates';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { MatDialog, MatDialogConfig, MatTabChangeEvent, MatRadioChange, MatDialogRef, MatSidenav } from '@angular/material';

import { UserService } from '../../../../../../services/user.service';
import { TranslateService } from '../../../../../../services/translate.service';
import { WksCentralService } from '../../../../services/wks-central.service';

import { ModalCommonComponent } from '../../../../../common/components/modal-common/modal-common.component';
import { WksEntityModel } from '../../../../models/wks-entity.model';
import { EquipItemModel, RevisionModel } from '../../../../models/wks-equipment.model';
import { ParamActionsrefModel, ParamWorksRatesModel, TasksActionsModel, TaskrefJsonModel,
  WksTasksModel, ParentTask, TasksActionsContentModel, IhmOptions, TaskSN, WorkStatutModel, 
  EventStatutCur} from '../../../../models/wks-param.model';
import { DataUpstream, TypesLabel} from '../../../../models/wks-common.model';

import { MessageDisplay } from '../../../../../../models/common.model';
import { LabelValue } from '../../../../../../models/data.model';
import { WksWorksModel } from '../../../../models/wks-works.model';
import { unescape } from 'querystring';

@Component({
  selector: 'mdi-works-jobstasks',
  templateUrl: './works-jobstasks.component.html',
  styleUrls: ['./works-jobstasks.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class WorksJobstasksComponent implements OnInit {

  @Input() statutCall: any;
  @Input() actionType: string;
  @Input() equipItem: EquipItemModel;
  @Input() workTasksContent: WksTasksModel[];
  @Input() ihmOptions: IhmOptions;
  @Input() workStatut: WorkStatutModel;
  @Input() wksWorks: WksWorksModel;
  @Output() dataOut = new EventEmitter<any>();
  @Output() dataValidTasks = new EventEmitter<any>();
  private readonly onDestroy = new Subject<void>();

  @ViewChild('filterActions', {static: false}) filterActions: ElementRef;
  @ViewChild('filterTasks', {static: false}) filterTasks: ElementRef;
  @ViewChild('taskReferencedModal', {read: TemplateRef, static: false}) taskReferencedModal: TemplateRef<any>;

  @ViewChild('sidenavRight', {static: false}) sidenavRight: MatSidenav;

 
  rowTask: number;
  allAvailable: boolean;
  isReadOnly: boolean;
  cacheActionsList: TasksActionsModel[];
  parentTask: ParentTask;
  parentTaskRef: ParentTask;
  openedAccordion: boolean;
  tasksActionsContent: TasksActionsContentModel;
  tasksActionsParentContent: TasksActionsContentModel;

  wksEntity: WksEntityModel;

  listActionsCur: ParamActionsrefModel[];
  listTasksCur: WksTasksModel[];
  tasksReferenced: WksTasksModel[];
  cacheTasksList: WksTasksModel[];
  workCodeList: LabelValue[];
  actionsReferenced: TasksActionsModel[];
  actionsSelected: TasksActionsModel[];

  dataUpstream: DataUpstream;
  priceOption: string;
  modalRef: BsModalRef;
  
  configModal = {
    class: 'modal-dialog-centered modal-works-tasks',
    backdrop: true,
    ignoreBackdropClick: true,
    animated: false,
    
  };
  messageDialogRef: MatDialogRef<ModalCommonComponent>;
 /*
  configModal = {
    class: 'modal-dialog-centered',
    backdrop: true,
    ignoreBackdropClick: true,
    animated: false,
    
  }*/
  allEquipmentsCheck: boolean;
  equipList: LabelValue[];
  equipListCheck: string[];
  openedRight: boolean;
  waitPricing: boolean[];
  okToDuplicate: boolean;
  // start new version code
  okToDisplay: boolean;

  rowJobsTask: {
    detailCollapse: boolean;
    isEven: boolean;
    isOdd: boolean;
    selected: boolean;
    waitPricing: boolean;
    workTask: WksTasksModel;
    equipments: LabelValue[];
    selectedEquipments: boolean;
  }[];
  // equipIdx: number;
  taskRowDisplay: number;
  rightSidenavCollapsed: boolean;
  verifyParts: boolean;
  workTasksContentInput: WksTasksModel[];
  // end new version code
  isAlreadyOpen: boolean;
  titleTask: string;
  constructor(
    private _userService: UserService, 
    private _translate: TranslateService,
    private _wksCentralService: WksCentralService,
    private modalService: BsModalService,
    private _dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.initData();
  }

  initData() {
    this.actionsSelected = [];
  
    this.initAllBooleans();
    this.initAllParam();
    this.initAllSubscribe();
    this.actionsSelected = [];
    this.wksEntity = this._wksCentralService.getWksEntityCur();
    this.equipList = this.equipItem.equipList;
    this.equipList.sort((obj1, obj2) => {
      return obj1.label > obj2.label ? 1 : -1;
    });
    if (this.workTasksContent !== undefined && this.workTasksContent !== null) {
      this.workTasksContentInput = JSON.parse(JSON.stringify(this.workTasksContent));
    }
   
    this.initRowsTasks();
    // this.okToDisplay = true;
  }
  initAllBooleans() {
    this.openedAccordion = false;

    this.allAvailable = false;
    this.isReadOnly = this.ihmOptions.readOnly;
    this.allEquipmentsCheck = true;
    this.waitPricing = [];
    this.okToDisplay = false;
    this.rightSidenavCollapsed = true;
    this.verifyParts = false;
    this.isAlreadyOpen = false;
    this.okToDuplicate = false;
  }

  initAllParam() {
    if (this.workStatut.label === 'accepted' || this.workStatut.label === 'approved') {
      this.verifyParts = true;
    }
    this.priceOption = (this._wksCentralService.getWksEntityCur().isQuotationActive ? 'withprice' : 'noprice');
    this.loadParamActionsRefByType(this.equipItem.equipType)
    .then ((responseType1: any) => {
   
    })
    .catch ((error: any) => {
      console.log('loadParamActionsRefByType : ' + error);
     
      return;
    });
    this.loadWorksType()
    .then ((responseWork: any) => {

    })
    .catch ((error: any) => {
      
      console.log('loadWorksType : ' + error);
      return;
    }); // end works type

  }
  initAllSubscribe() {

    this._wksCentralService.taskWksEvent
      .pipe(takeUntil(this.onDestroy))
      .subscribe( event => {
        if (event.todo === 'changeValuesWorks') {
          this.setContentTask(event.orig, event.content as TasksActionsContentModel);
        } else if (event.todo === 'newTaskRef') {
          const newTask = event.content as WksTasksModel;
          this.tasksReferenced.push(newTask);
          this.affectTooltip(this.tasksReferenced);
          if ( this.parentTaskRef !== undefined &&  this.parentTaskRef.statutCall === 'modal') {
            this.closeModal();
          }
        } else if (event.todo === 'closeTaskRef') {
          if ( this.parentTaskRef !== undefined &&  this.parentTaskRef.statutCall === 'modal') {
            this.closeModal();
          }
        } else if (event) {
          const typeEvent = typeof event;
          const eventString = String(event);
        }
      });
  
    }
  // work ref 
loadWorksType() {
  let dataReturn: ParamWorksRatesModel[];
  this.workCodeList = [];
  return new Promise((resolve, reject) => {
    this._wksCentralService.getWksWorkRatesList(this._userService.getUserLogged().entity, this._userService.getUserLogged().userlang)
  .pipe(takeUntil(this.onDestroy))
  .subscribe(
      data => {
          dataReturn = data.body;
          for (const workCurTmp of dataReturn) {
            const corkCurItem: LabelValue = {
              label: workCurTmp.workLabel,
              value: workCurTmp.workCode
            };
            this.workCodeList.push(corkCurItem);
          }
          this.workCodeList.sort((obj1: LabelValue, obj2: LabelValue) => {
            return obj1.label > obj2.label ? 1 : -1;
          });
          this.workCodeList.splice(0, 0, {
              label: '',
              value: ''
          });
          resolve(dataReturn) ;
        }, err => {
          console.log(err);
          reject(err.status);
        }
      );
    });
  }
  loadParamActionsRefByType(_equipType: string) {
    return new Promise((resolve, reject) => {
      this._wksCentralService.getParamActionsRefByTypeList(this._userService.getUserLogged().entity, 
                                                _equipType, this._userService.getUserLogged().userlang)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(
        data => {
          const actionsRead = data.body as ParamActionsrefModel[];
          this.listActionsCur = [...actionsRead];
          this.initActionsReferencedList();
          resolve(actionsRead);
        },
        err => {
          console.log(err);
          reject(err.status);
        }
      );
    });
  }
  initActionsReferencedList() {
    this.actionsReferenced = [];
    this.cacheActionsList = [];
    for (const actionReading of this.listActionsCur)  {
      this.actionsReferenced.push({
        brandRef: actionReading.brandRef,
        actionrefLabel: actionReading.actionrefLabel,
        billingUnit: this._translate.getTranslate(actionReading.billingUnit.trim()),
        selected: false,
      });
      this.cacheActionsList.push({
        brandRef: actionReading.brandRef,
        actionrefLabel: actionReading.actionrefLabel,
        billingUnit: this._translate.getTranslate(actionReading.billingUnit.trim()),
        selected: false,
      });

    }
    if (this.actionsReferenced.length > 0) {
      this.actionsReferenced.sort(function(obj1, obj2) {
        return obj1.actionrefLabel > obj2.actionrefLabel ? 1 : -1;
      });

    } else {
      // this.toReferenced = true;
    }
    if ((this.actionsSelected === undefined) || (this.actionsSelected.length === 0)) {
      // this.toSelected = true;
    } else {
      this.actionsSelected.sort(function(obj1, obj2) {
        return obj1.ranking > obj2.ranking ? 1 : -1;
      });
    }
  }
  initRowsTasks(): void {

    if (this.workTasksContentInput === null 
      || this.workTasksContentInput === undefined 
      || this.workTasksContentInput.length === 0) {
      this.okToDisplay = true;
      return;
    }
    this.rowJobsTask = [];
    this.waitPricing = [];
    let tasksActions: TasksActionsContentModel;
    let pricingOK = 0;
    let idxTask = 0;
    for (const taskRefContent of this.workTasksContentInput) {
      pricingOK = 0;
      taskRefContent.ranking = idxTask;
      const taskrefJson = JSON.parse(taskRefContent.taskrefJson);
      if (taskrefJson.tasksActionsParentContent !== undefined) {
        tasksActions = taskrefJson.tasksActionsParentContent as TasksActionsContentModel;
        if (tasksActions.supplies) {
          pricingOK += (this.verifActionPricing(tasksActions.supplies) ? 1 : 0 );
        } 

        if (tasksActions.works) {
          pricingOK += (this.verifActionPricing(tasksActions.works) ? 1 : 0 );
        } 
      } 
      const tasksActionsContent  = taskrefJson.tasksActionsContent;
      
      if (tasksActionsContent !== undefined) {
        tasksActions = taskrefJson.tasksActionsContent as TasksActionsContentModel;
        if (tasksActions.supplies) {
          pricingOK += (this.verifActionPricing(tasksActions.supplies) ? 1 : 0 );
        } 

        if (tasksActions.works) {
          pricingOK += (this.verifActionPricing(tasksActions.works) ? 1 : 0 );
        } 
        const newRowRask = JSON.parse(JSON.stringify(this.getEmptyRowTask()));
        this.waitPricing [idxTask] = pricingOK > 0 ? true : false;
        newRowRask.workTask = taskRefContent;
        newRowRask.waitPricing = pricingOK > 0 ? true : false;
        newRowRask.isEven = (idxTask % 2 === 0 ? true : false);
        newRowRask.isOdd = (idxTask % 2 !== 0 ? true : false);
        newRowRask.equipments = [];
        // const equipments: LabelValue[] = [];
        if (tasksActionsContent.equipments.all) {
          for (const equipCur of this.equipItem.equipList) {
            equipCur.selected = true;
            newRowRask.selectedEquipments = true;
            newRowRask.equipments.push(equipCur);
          }
        } else {
          for (const equipItem of this.equipItem.equipList) {
            for ( const equipCur of tasksActionsContent.equipments.equipId) {
              equipItem.selected = false;
              if (equipItem.value === equipCur) {
                equipItem.selected = true;
                newRowRask.selectedEquipments = true;
                break;
              }
            }
            newRowRask.equipments.push(equipItem);
          }
        }
        let idxEquip = 0;
        for (const equipment of newRowRask.equipments) {
          equipment.isEven = (idxEquip % 2 === 0 ? true : false);
          equipment.isOdd = (idxEquip % 2 !== 0 ? true : false);
          idxEquip++;
        }
        this.rowJobsTask.push(JSON.parse(JSON.stringify(newRowRask)));
      } 
      idxTask++;
    }
    // this.verifPrincing();
    this.okToDisplay = true;
  }
  getEmptyRowTask(): any  {
    return  {
      detailCollapse: true,
      isEven: false,
      isOdd: false,
      selected: false,
      waitPricing: [],
      workTask: undefined,
      equipments: [],
      selectedEquipments: false
    };
  }
  verifActionPricing(taskListCur: TasksActionsModel[]): boolean {
    let waitPrincing = false;
    for (const actionCur of taskListCur) {
      if (actionCur.extPrice === 0 || actionCur.extPrice === undefined  || actionCur.extPrice <= 0 ) {
        waitPrincing = true;
      }
    }
    return waitPrincing;
  }
  toggleRowTask(idxRow: number, isCollapsed: boolean): void {
    this.rowJobsTask[idxRow].detailCollapse = !this.rowJobsTask[idxRow].detailCollapse;
    for (const itemTask of this.rowJobsTask) {
      itemTask.selected = false;
    }
    if (!this.rowJobsTask[idxRow].detailCollapse) {
      this.rowJobsTask[idxRow].selected = true;
    }
    
  }
  setTaskLabelValue(_value: any, _idxTask: number) {
    this.workTasksContentInput[_idxTask].taskrefLabel = _value;
    this.rowJobsTask[_idxTask].workTask.taskrefLabel = _value;
  }
  selectedEquipement(_idxTask: number, _idxEquip: number, equipmentCur?: any) {
    // console.log(equipmentCur);
    const situation = this.rowJobsTask[_idxTask].equipments[_idxEquip].selected;
    this.rowJobsTask[_idxTask].equipments[_idxEquip].selected = !situation;
    this.rowJobsTask[_idxTask].selectedEquipments = false;
    for (const equipement of this.rowJobsTask[_idxTask].equipments) {
      if (equipement.selected) {
        this.rowJobsTask[_idxTask].selectedEquipments = true;
        break;
      }
    }
    this.affectEquipIdsToTask(_idxTask);
    
  }
  affectEquipIdsToTask(_idxTask: number): void  {
    const taskCur = this.rowJobsTask[_idxTask].workTask;

    if (taskCur.taskrefJson !== undefined) {
      const taskrefJsonTmp = JSON.parse(taskCur.taskrefJson);
      if (taskrefJsonTmp.tasksActionsParentContent !== undefined) {
        this.tasksActionsParentContent = taskrefJsonTmp.tasksActionsParentContent as TasksActionsContentModel;
      }
      const tasksActionsContent  = taskrefJsonTmp.tasksActionsContent;
      if (tasksActionsContent !== undefined) {
        this.tasksActionsContent = tasksActionsContent as TasksActionsContentModel;
      }
    }
    this.tasksActionsContent.equipments.equipId =  this.getEquipSelectedListId(_idxTask);
    const taskrefJson: TaskrefJsonModel = {
      tasksActionsContent: this.tasksActionsContent,
      tasksActionsParentContent: ( this.tasksActionsParentContent ? this.tasksActionsParentContent : undefined),
      tasksActionCompleted: undefined
    };
    this.workTasksContentInput[_idxTask].taskrefJson =  JSON.stringify(taskrefJson);
    this.rowJobsTask[_idxTask].workTask.taskrefJson =  JSON.stringify(taskrefJson);

    this.dataOut.emit(this.workTasksContentInput);
    this.toggleValidOK(true);
  }
  addTask(): void {

    if (this.workTasksContentInput === null 
      || this.workTasksContentInput === undefined 
      || this.workTasksContentInput.length === 0) {
        this.workTasksContentInput = [];
    }
    const newRowRask = JSON.parse(JSON.stringify(this.getEmptyRowTask()));
    newRowRask.workTask = JSON.parse(JSON.stringify(this.getEmptyTask()));
    newRowRask.waitPricing = true;
    newRowRask.isEven = false;
    newRowRask.isOdd = false;
    newRowRask.equipments = [];
    let idxEquip = 0;
    for (const equipCur of this.equipItem.equipList) {
      equipCur.selected = false;
      if (this.equipItem.equipList.length === 1) {
        equipCur.selected = true;
      }
      equipCur.isEven = (idxEquip % 2 === 0 ? true : false);
      equipCur.isOdd = (idxEquip % 2 !== 0 ? true : false);
      // equipCur.jsonData = JSON.parse(JSON.stringify(equipCur.jsonData));
      idxEquip++;
      newRowRask.equipments.push(equipCur);
    }
    
    if (this.rowJobsTask === undefined) {
      this.rowJobsTask = [];
    }
    this.rowJobsTask.push(newRowRask);
    
    this.workTasksContentInput.push(JSON.parse(JSON.stringify(this.getEmptyTask())));
    if (this.equipItem.equipList.length === 1) {
      this.rowJobsTask[this.rowJobsTask.length - 1].equipments[0].selected = true;
      this.rowJobsTask[this.rowJobsTask.length - 1].selectedEquipments = true;
    }
    
    this.openedAccordion = false;
    // console.log(JSON.parse(JSON.stringify(this.rowJobsTask)));
  } 
  getEmptyTask(): WksTasksModel {

    const tasksrefValidation: WksTasksModel = {
      id: undefined,
      stdEntity: this._userService.getUserLogged().entity,
      taskrefId: undefined,
      taskrefLabel: undefined,
      taskrefRow: undefined,
      taskrefParent: undefined,
      equipType: undefined,
      equipBrand: undefined,
      equipModel: undefined,
      partRef: undefined,
      workCode: undefined,
      actionrefType: undefined,
      actionrefId: undefined,
      taskrefJson: JSON.stringify(this.getEmptyTaskRefJson()),
      stdCreation: undefined,
      langLabels: undefined,
      userLang: this._userService.getUserLogged().userlang,
      taskrefSN: undefined,
    };
    return tasksrefValidation;
  }
  getEmptyTaskRefJson(): TaskrefJsonModel {
    const taskActionContent: TasksActionsContentModel = {
      supplies: [],
      works: [],
      services: [],
      equipments: {
          all: false,
          equipId: [],
      },
      rowTask: -1
    };
    const taskrefJsonModel: TaskrefJsonModel =  {
      unitquantity: undefined,
      taskrefComment: undefined,
      tasksActionsContent: taskActionContent,
      tasksActionsParentContent: undefined,
    };
    return taskrefJsonModel;
  }
  taskSelectRemoveOK( _idxTask: number): void {

    // const messageContent = workTasksContentInput.taskrefLabel + ' \n ' + this.equipList[_idxEquip].label + ' (SN ' +  this.equipList[_idxEquip].otherData + ') ';
    const label = this.rowJobsTask[_idxTask] !== undefined &&  this.rowJobsTask[_idxTask].workTask.taskrefLabel ? this.rowJobsTask[_idxTask].workTask.taskrefLabel : '';
    let messageContent = '';
    if (label !== '') {
      messageContent = '<div><b>' + this._translate.getTranslate('removeTask') + ' : ' + label + '</b></div>' ;
    } else {
      messageContent = '<div><b>' + this._translate.getTranslate('removeTask') + '</b></div>' ;
    }
    
    this.displayMessage('removeTask', messageContent, _idxTask);
  }
  taskSelectedRemove( _idxTask: number) {

    this.rowJobsTask.splice(_idxTask, 1);
    this.workTasksContentInput[_idxTask].disabledTask = true;
    this.openedAccordion = false;
    this.allEquipmentsCheck = false;
    this.rowTask = this.workTasksContentInput.length - 1 ;
    this.dataOut.emit(this.workTasksContentInput);
    this.toggleValidOK(true);
   
  }
  duplicateTask(): void  {

    const label =  this.rowJobsTask[this.rowTask].workTask.taskrefLabel ;
    const messageContent = '<div><b>' + this._translate.getTranslate('duplicateTask') + ' : ' + label + '</b></div>' ;
    this.displayMessage('duplicateTask', messageContent, this.rowTask);
  }
  duplicateSelectedTask( _idxTask: number): void {
    // console.log(this.rowTask);
    const newTask = JSON.parse(JSON.stringify( this.rowJobsTask[this.rowTask].workTask));
    newTask.stdCreation = undefined;
    newTask.lastUpdateDate = undefined;
    newTask.id = undefined;
    newTask.taskrefRow = 'reference';
    newTask.workId = undefined;
    newTask.taskrefOrig = undefined;
    newTask.equipType = this.equipItem.equipType;
    newTask.equipBrand = this.equipItem.equipBrand;
    newTask.equipModel = this.equipItem.equipModel;

    this.registerTaskRef(newTask);
  }

  onChangeActionSidenav(_value: string) {

    // console.log('sidenav action ' + _value);
  }
  displaySelectedTask(_idxTask: number): void {
    this.okToDuplicate = false;
    const taskCur = this.rowJobsTask[_idxTask].workTask;
    if (taskCur.taskrefOrig === undefined) {
      this.okToDuplicate = true;
    }
    for (const itemTask of this.rowJobsTask) {
      itemTask.selected = false;
    }
    this.rowJobsTask[_idxTask].selected = true;
    this.rowTask = _idxTask;
    this.tasksActionsParentContent = undefined;
    this.tasksActionsContent = undefined;
    if (taskCur.taskrefJson !== undefined) {
      const taskrefJson = JSON.parse(taskCur.taskrefJson);
      if (taskrefJson.tasksActionsParentContent !== undefined) {
        this.tasksActionsParentContent = taskrefJson.tasksActionsParentContent as TasksActionsContentModel;
      }
      const tasksActionsContent  = taskrefJson.tasksActionsContent;
      if (tasksActionsContent !== undefined) {
        this.tasksActionsContent = tasksActionsContent as TasksActionsContentModel;
      }
    }
    this.tasksActionsContent.equipments.equipId =  this.getEquipSelectedListId(_idxTask);
    
    this.parentTask = {
      rootParam:  this.workTasksContentInput[_idxTask],
      parentParam:  this.workTasksContentInput[_idxTask],
      statutCall: 'sidenav',
      stdEntity: this._userService.getUserLogged().entity, 
      userlang: this._userService.getUserLogged().userlang
    };
    this.refreshTaskReferenced();
    this.isAlreadyOpen = false;
    this.titleTask = taskCur.taskrefLabel;
    this.openedAccordion = true;
  }

  toggleValidOK(isValid: boolean): void {
    const validOK = {
      validOK: isValid
    };
    this.dataValidTasks.emit(validOK);
  }
  setContentTask(_origEvent: string, _contentEvent: TasksActionsContentModel) {
    // const rowLocal = parseInt(_origEvent, 0); 
    this.isAlreadyOpen = true;
    let rowTask: number;
    rowTask = _contentEvent.rowTask;
 
    if (this.tasksActionsContent === undefined) {
 
      this.tasksActionsContent = {
        works: [],
        supplies : [],
        services : [],
        equipments: {
          all: false,
          equipId: this.getEquipSelectedListId(rowTask)
        },
      };
    }

    if ((_origEvent === 'supplies&parts') && (_contentEvent.supplies)) {
      this.allAvailable = true;
      const contentSupplies: TasksActionsModel[] = [];
      const parentSupplies: TasksActionsModel[] = [];
      
      for (const itemSupplie of  _contentEvent.supplies) {
        if (itemSupplie.parentElement) {
          parentSupplies.push(itemSupplie);
        } else  {
          contentSupplies.push(itemSupplie);
        }
      }
      this.tasksActionsContent.supplies = contentSupplies;
      if (this.tasksActionsParentContent !==  undefined) {
        this.tasksActionsParentContent.supplies = parentSupplies;
      }
      // this.tasksActionsContent.supplies = _contentEvent.supplies;
      for (const wksTask of this.tasksActionsContent.supplies ) {
        if (!wksTask.available) {
          this.allAvailable = false;
        }
      }
      if (this.tasksActionsParentContent !==  undefined) {
        for (const wksTask of this.tasksActionsParentContent.supplies ) {
          if (!wksTask.available) {
            this.allAvailable = false;
          }
        }
      }
    }
    if ((_origEvent === 'services') && (_contentEvent.supplies)) {
      this.allAvailable = true;
      const contentServices: TasksActionsModel[] = [];
      const parentServices: TasksActionsModel[] = [];

      for (const itemSupplie of  _contentEvent.services) {
        if (itemSupplie.parentElement) {
          parentServices.push(itemSupplie);
        } else  {
          contentServices.push(itemSupplie);
        }
      }
      this.tasksActionsContent.services = contentServices;
      if (this.tasksActionsParentContent !==  undefined) {
        this.tasksActionsParentContent.services = parentServices;
      }

      for (const wksTask of this.tasksActionsContent.services ) {
        if (!wksTask.available) {
          this.allAvailable = false;
        }
      }
      if (this.tasksActionsParentContent !==  undefined) {
        for (const wksTask of this.tasksActionsParentContent.services ) {
          if (!wksTask.available) {
            this.allAvailable = false;
          }
        }
      }
    }
    if ((_origEvent === 'works') && (_contentEvent.works)) {
      const contentWorks: TasksActionsModel[] = [];
      const parentWorks: TasksActionsModel[] = [];
      for (const itemWork of  _contentEvent.works) {
        if (itemWork.parentElement) {
          parentWorks.push(itemWork);
        } else  {
          contentWorks.push(itemWork);
        }
      }
      this.tasksActionsContent.works = contentWorks;
      if (this.tasksActionsParentContent !==  undefined) {
        this.tasksActionsParentContent.works = parentWorks;
      }
    }

    this.tasksActionsContent.equipments = { all: false, equipId: this.getEquipSelectedListId(rowTask) };
    /*=====================================*/
    if (this.workTasksContentInput !== null 
          && this.workTasksContentInput !== undefined 
          && this.workTasksContentInput[rowTask] !== undefined 
          && this.workTasksContentInput[rowTask].taskrefJson !== undefined) {
      const taskrefJson = JSON.parse(this.workTasksContentInput[rowTask].taskrefJson) as TaskrefJsonModel;
      taskrefJson.tasksActionsContent = this.tasksActionsContent;
      taskrefJson.tasksActionsParentContent = ( this.tasksActionsParentContent ? this.tasksActionsParentContent : undefined);
      this.workTasksContentInput[rowTask].taskrefJson =  JSON.stringify(taskrefJson);
    } else  {
      const taskrefJson: TaskrefJsonModel = {
        tasksActionsContent: this.tasksActionsContent,
        tasksActionsParentContent: ( this.tasksActionsParentContent ? this.tasksActionsParentContent : undefined),
        tasksActionCompleted: undefined
      };
  
      if (this.workTasksContentInput !== null &&
        this.workTasksContentInput !== undefined ) {
          this.workTasksContentInput[rowTask].taskrefJson =  JSON.stringify(taskrefJson);
        }  
    }
    // JLG TEST
    // console.log(this.workTasksContentInput[rowTask].taskrefJson);
    if (this.verifPrincing()) {
      this.dataOut.emit(this.workTasksContentInput);
    }

  }
  verifPrincing(): boolean {
    if (this.workTasksContentInput === undefined 
      || this.workTasksContentInput === null 
      || this.workTasksContentInput.length === 0) {
      return false;
    }
    let idxRow = 0;
    let pricingOK = true; 
    let tasksActions: TasksActionsContentModel;
    for (const taskCur of this.workTasksContentInput) {

      try {
        const taskrefJson = JSON.parse( taskCur.taskrefJson);
        const tasksActionsContent  = taskrefJson.tasksActionsContent;
        if (tasksActionsContent !== undefined) {
          tasksActions = taskrefJson.tasksActionsContent as TasksActionsContentModel;

          if (tasksActions.supplies) {
            this.waitPricing[idxRow] = this.verifActionPricing(tasksActions.supplies);
          } 
          if (this.waitPricing[idxRow])  {
            pricingOK = false;
            break;
          }
          if (tasksActions.services) {
            this.waitPricing[idxRow] = this.verifActionPricing(tasksActions.services);
          } 
          if (this.waitPricing[idxRow])  {
            pricingOK = false;
            break;
          }
          if (tasksActions.works) {
            this.waitPricing[idxRow] = this.verifActionPricing(tasksActions.works);
          } 
          if (this.waitPricing[idxRow])  {
            pricingOK = false;
            break;
          }
        }
        if (taskrefJson.tasksActionsParentContent !== undefined) {
          tasksActions = taskrefJson.tasksActionsParentContent as TasksActionsContentModel;
          if (tasksActions.supplies) {
            this.waitPricing[idxRow] = this.verifActionPricing(tasksActions.supplies);
          } 
          if (this.waitPricing[idxRow])  {
            pricingOK = false;
            break;
          }
          if (tasksActions.works) {
            this.waitPricing[idxRow] = this.verifActionPricing(tasksActions.works);
          } 
          if (this.waitPricing[idxRow])  {
            pricingOK = false;
            break;
          }
        }
      } catch (error) {
      } finally {
        this.rowJobsTask[idxRow].waitPricing = this.waitPricing[idxRow];
       }
      idxRow++;
    }
    return pricingOK;
  }
  statutCur(event: EventStatutCur): void  {
      // console.log(event);
    if (event.subject === 'partsSupplies') {
      this.toggleValidOK(!event.failed);
    } 
    if (event.subject === 'services') {
      this.toggleValidOK(!event.failed);
    } 
    if (event.subject === 'works') {
      this.toggleValidOK(!event.failed);
    } 
  }
  loadParamTasksRefByType(_equipType: string, _equipBrand: string, _equipModel: string, _equipSN: string, _taskList: string) {
    this.tasksReferenced = [];
    this.cacheTasksList = [];
    this.listTasksCur = [];
    this.readParamTasksRefByType(_equipType, _equipBrand, _equipModel, _equipSN)
    .then ((tasksRead1) => {
      const tasksRead11  = tasksRead1 as WksTasksModel[];
      this.listTasksCur = this.excludeManufacturerAttNotRevisions(tasksRead11);
      if (_equipSN !== undefined && _equipSN !== null && _equipSN !== '') {
        this.listTasksCur = [];
        this.listTasksCur = this.getRestrictedList(tasksRead11, _equipSN);
      }

      if (_taskList !== undefined) {
        this.readParamTasksRefByRevision(_taskList)
        .then ((tasksRead2) => {
          // this.listTasksCur = [...tasksRead2];
          this.listTasksCur = this.listTasksCur.concat(tasksRead2);
          this.generateLisTasks();
        })
        .catch ((error: any) => {
          console.log('readParamTasksRefByRevision : ' + error);
          this.generateLisTasks();
        });
      } else {
        this.generateLisTasks();
      } 
    })
    .catch ((error: any) => {
      console.log('readParamTasksRefByType : ' + error);
      return;
    });

  }
  refreshTaskReferenced(): void {
  /*
   equipSN: (equipRow.otherData !== null ? equipRow.otherData : ''),
   revisions: equipRow.otherValues,
  */
    const equipRow = this.getFirstEquipSelected();
    const equipSN = (equipRow.otherData !== null ? equipRow.otherData : '');

    const revisionsList = this.getRevisionList(equipRow.otherValues);

    this.loadParamTasksRefByType( this.equipItem.equipType,
                                  this.equipItem.equipBrand,
                                  this.equipItem.equipModel,
                                  equipSN,
                                  revisionsList);
  }
  getEquipListId(): string[] {
    const equipIdList: string[] = []; 
    for (const equipment of this.rowJobsTask[this.rowTask].equipments) {
      equipIdList.push(equipment.value);
    }
    return equipIdList;
  }
  getEquipSelectedListId(rowTask: number): string[] {
    const equipIdList: string[] = []; 
    for (const equipment of this.rowJobsTask[rowTask].equipments) {
      if (equipment.selected) {
        equipIdList.push(equipment.value);
      }
    }
    return equipIdList;
  }
  getFirstEquipSelected(): LabelValue {
    let firtSelectedEquipment: LabelValue;
    for (const equipment of this.rowJobsTask[this.rowTask].equipments) {
      if (equipment.selected) {
        firtSelectedEquipment = equipment;
        break;
      }
    }
    return firtSelectedEquipment;
  }
 
  getRevisionList(revisions: RevisionModel[]): string {
    let revisionsList = '';
    if (revisions === undefined) {
      return;
    }
    let idxRevision = 0;
    for (const revision of revisions) {
      if (idxRevision === 0) {
        revisionsList = revision.taskrefId;
      } else  {
        revisionsList += ';' +  revision.taskrefId;
      }
      idxRevision++;
    }
    return revisionsList;
  }
  excludeManufacturerAttNotRevisions(tasksRead1: WksTasksModel[]): WksTasksModel[] {
    const filtredTasksList: WksTasksModel[] = [];
    for (const taskCur of tasksRead1) {
      const taskRefJson = JSON.parse(taskCur.taskrefJson) as TaskrefJsonModel;
      if (taskRefJson.jobManufacturerAtt !== undefined) {
        const jobManufacturerAtt = taskRefJson.jobManufacturerAtt;
        if (!jobManufacturerAtt.specType.startsWith('revision')) {
          continue;
        } else {
          filtredTasksList.push(taskCur);
        } 
      } else {
        filtredTasksList.push(taskCur);
      } 
    }
    return filtredTasksList;
  }
  generateLisTasks(): void  {

    this.tasksReferenced = [...this.listTasksCur];
    this.affectTooltip(this.tasksReferenced);
    for ( const taskRef of this.tasksReferenced) {
      taskRef.selectedTask = false;
      taskRef.taskrefLabel += (taskRef.equipBrand ? ' - ' + taskRef.equipBrand : '' );
      taskRef.taskrefLabel += (taskRef.equipModel ? ' - ' + taskRef.equipModel : '' );
    }
   
    this.cacheTasksList = [...this.tasksReferenced];
  }

  affectTooltip(tasksList: WksTasksModel[]): void {

    for (const taskRef of tasksList) {
        let taskrefSN: TaskSN[] = [];

        if ((taskRef.taskrefSN !== undefined) && (taskRef.taskrefSN !== null)) {
          try {
            const taskrefSNJson = JSON.parse(taskRef.taskrefSN);
            taskrefSN = [...taskrefSNJson];
          } catch {
            taskrefSN = [];
          }
        }
        let tooltipTmp = '';
        let idxRow = 0;
        if (taskrefSN.length > 0) { 
          if (tooltipTmp === '') { 
            tooltipTmp = this._translate.getTranslate('snFrom') + ' : ' + taskrefSN[idxRow].snFrom;
            tooltipTmp += ' >> ';
            tooltipTmp += this._translate.getTranslate('snUpto') + ' : '  + taskrefSN[idxRow].snUpto ;
            /* tooltipTmp += '\n';
            tooltipTmp += 'test';*/
          } else  { 
            tooltipTmp += '\n';
            tooltipTmp += this._translate.getTranslate('snFrom') + ' : ' + taskrefSN[idxRow].snFrom;
            tooltipTmp += ' >> ';
            tooltipTmp += this._translate.getTranslate('snUpto') + ' : '  + taskrefSN[idxRow].snUpto ;
          }
          idxRow++;
        } else {
          tooltipTmp = this._translate.getTranslate('allSN');
        } 
        taskRef.snTooltip = tooltipTmp;
      }
  }


  getRestrictedList(tasksRead: WksTasksModel[], _equipSN: string): WksTasksModel[] {
    const restrictedList: WksTasksModel[] = [];

    for ( const taskCur of tasksRead) {
     
      if (taskCur.taskrefSN === null 
        || taskCur.taskrefSN === undefined 
        || taskCur.taskrefSN === '') {
          restrictedList.push(taskCur);
          continue;
      } else {
        let okToList: boolean;
        let taskrefSN: TaskSN[] = [];
        try {
          const taskrefSNJson = JSON.parse(taskCur.taskrefSN);
          taskrefSN = [...taskrefSNJson];
          okToList = this.searchSNRange(taskrefSN, _equipSN);
        } catch {
          taskrefSN = [];
          okToList = false;
        }

        if (okToList) {
          restrictedList.push(taskCur);
          continue;
        }
      }
        
    }

    return restrictedList;
  } 
  searchSNRange(parentSN: TaskSN[], _equipSN: string): boolean {
    let okToList: boolean;
    let fromOK: boolean;
    let uptoOK: boolean;
    let betweenOK: boolean;
    let testBetween: boolean;
    for (const parentItemSN of parentSN ) {
      okToList = false;
      fromOK = false;
      uptoOK = false;
      betweenOK = false;
      testBetween = true;
      if (parentItemSN.snFrom === null || parentItemSN.snFrom === undefined || parentItemSN.snFrom === '') {
        fromOK = true;
        betweenOK = true;
        testBetween = false;
      }
      if (parentItemSN.snUpto === null || parentItemSN.snUpto === undefined || parentItemSN.snUpto === '') {
        uptoOK = true;
        betweenOK = true;
        testBetween = false;
      }
      if (testBetween) {
        if (_equipSN < parentItemSN.snFrom ) {
          fromOK = false;
        } else {
          fromOK = true;
        }
        if (_equipSN > parentItemSN.snUpto ) {
          uptoOK = false;
        } else {
          uptoOK = true;
        }
        if (uptoOK && fromOK ) {
          betweenOK = true;
        }
      }
      if (uptoOK && fromOK && betweenOK) {
        okToList = true;
        break;
      }
    }
    return okToList;
  }
  readParamTasksRefByType(_equipType: string, _equipBrand: string, _equipModel: string, _equipSN: string) {
    return new Promise((resolve, reject) => {
     
      this._wksCentralService.getParamTasksrefByTypeList(this._userService.getUserLogged().entity, 
                        _equipType, this._userService.getUserLogged().userlang, _equipBrand, _equipModel)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(
        data => {
          const tasksRead = data.body;
          resolve(tasksRead);
      },
      err => {
        console.log(err);
        reject(err.status);
        }
      );
    });
  }
  readParamTasksRefByRevision( _taskList: string) {

    return new Promise((resolve, reject) => {
     
      this._wksCentralService.getTaskRefList(this._userService.getUserLogged().entity,  this._userService.getUserLogged().userlang, _taskList)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(
        data => {
          const tasksRead = data.body;
          resolve(tasksRead);
      },
      err => {
        console.log(err);
        reject(err.status);
        }
      );
    });
  }
  onChangeWorkTask($event: any) {
    this.tasksReferenced = [];
    this.cacheTasksList = [];
    if (this.listTasksCur === undefined) {
      return;
    }
    if ($event !== '') {
      for (const taskReading of this.listTasksCur)  {
        if (taskReading.workCode === $event) {
          taskReading.selectedTask = false;
          this.tasksReferenced.push(taskReading);
          this.affectTooltip(this.tasksReferenced);
          this.cacheTasksList.push(taskReading);
        }
      }
      if (this.tasksReferenced.length > 0) {
        this.tasksReferenced.sort(function(obj1, obj2) {
          return obj1.taskrefLabel > obj2.taskrefLabel ? 1 : -1;
        });
        if ((this.workTasksContentInput !== undefined) && (this.workTasksContentInput.length > 0 )) {      
          for (const taskSel of this.workTasksContentInput) {
            let numRow = 0;
            for ( const taskRef of this.tasksReferenced) {
              if (taskRef.taskrefId === taskSel.taskrefOrig) {
                // this.tasksReferenced.splice(numRow, 1);
                taskRef.selectedTask = true;
                break;
              }
              numRow++;
            }
          }
        }

      } 
    } else {
      this.tasksReferenced = [...this.listTasksCur];
      this.cacheTasksList = [...this.listTasksCur];
      this.affectTooltip(this.tasksReferenced);
    }
    if (this.verifPrincing()) {
  
    }
  }
  toggleSidenavRight(_arg: string) {

    if (_arg === 'close') {
      this.rightSidenavCollapsed = true;
      try {
        this.sidenavRight.close();
      } catch (error) {
      } finally { }
      return;
    }
    this.rightSidenavCollapsed = !this.rightSidenavCollapsed;
    if (this.rightSidenavCollapsed) {
      try {
        this.sidenavRight.close();
      } catch (error) {
      } finally { }
    } else {
      try {
        this.sidenavRight.open();
      } catch (error) {
      } finally { }
    }
  }
  referencedToSelectedTask(_idx: number) {
   
    if (this.workTasksContentInput === undefined || this.workTasksContentInput === null) {
      this.workTasksContentInput = [];
    }
    this.rowJobsTask[this.rowTask].workTask = this.tasksReferenced[_idx];
    this.titleTask = this.rowJobsTask[this.rowTask].workTask.taskrefLabel;
    
    this.toggleSidenavRight('');

    this.parentTask = {
      rootParam:  this.tasksReferenced[_idx],
      parentParam:  this.tasksReferenced[_idx],
      statutCall: 'sidenav',
      stdEntity: this._userService.getUserLogged().entity, 
      userlang: this._userService.getUserLogged().userlang
    };
    this.tasksActionsParentContent = undefined;
    this.tasksActionsContent = undefined;
    const taskrefJson = JSON.parse( this.tasksReferenced[_idx].taskrefJson);

    const tasksActionsContent  = taskrefJson.tasksActionsContent;
    if (tasksActionsContent !== undefined) {
      this.tasksActionsContent = taskrefJson.tasksActionsContent as TasksActionsContentModel;
      this.tasksActionsContent.equipments = { all: false, equipId: this.getEquipSelectedListId(this.rowTask) };
      this.allEquipmentsCheck = false;
    }
    if (taskrefJson.tasksActionsParentContent !== undefined) {
      this.tasksActionsParentContent = taskrefJson.tasksActionsParentContent as TasksActionsContentModel;
    }
    const taskSelectedTmp = JSON.parse(JSON.stringify( this.tasksReferenced[_idx]));
    taskSelectedTmp.taskrefOrig = this.tasksReferenced[_idx].taskrefId;
    taskSelectedTmp.taskrefId = this.tasksReferenced[_idx].taskrefId;
    taskSelectedTmp.id = undefined;
    taskSelectedTmp.disabledTask = false;
    taskrefJson.tasksActionsContent = this.tasksActionsContent;
    taskrefJson.tasksActionsParentContent = ( this.tasksActionsParentContent ? this.tasksActionsParentContent : undefined);
    taskSelectedTmp.taskrefJson = JSON.stringify(taskrefJson);
    taskSelectedTmp.ranking = this.rowTask;
    /* old code
    this.workTasksContentInput.push(taskSelectedTmp);

    this.rowTask = this.workTasksContentInput.length - 1 ;
    */
   // New code
    this.workTasksContentInput[this.rowTask] = taskSelectedTmp;

    this.tasksReferenced[_idx].selectedTask = true;
    if (this.verifPrincing()) {
      this.dataOut.emit(this.workTasksContentInput);
    } else {
      this.rowJobsTask[this.rowTask].waitPricing = true;
      this.toggleValidOK(false);
    }
    this.openedAccordion = true;
  }
  onKeyFilterTasks($event: any) {
    // console.log(value);
    if ( ($event === '' ) || ($event.target.value === '' )) {
      this.tasksReferenced = [...this.cacheTasksList];
      this.affectTooltip(this.tasksReferenced);
      return;
    }
    let valueFinal: any;
    if ($event === '') {
      valueFinal = '';
    } else  {
      valueFinal = $event.target.value;
      if ( $event.keyCode === 32) {
        valueFinal += ' ';
      }
    }
    this.tasksReferenced = this.searchTasks(valueFinal);
    this.affectTooltip(this.tasksReferenced);
    this.filterTasks.nativeElement.value = valueFinal;
  }
  searchTasks(value: string) { 
    const filter = value.toLowerCase();
    return this.tasksReferenced.filter(taskCur => taskCur.taskrefLabel.toLowerCase().includes(filter));
  }
  // managing sidenav content
  dropTasks(event: CdkDragDrop<string[]>) {
    moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
  }
  registerTaskRef(taskToDuplicate: WksTasksModel) {

    this._wksCentralService.saveParamTasksref(taskToDuplicate, taskToDuplicate.stdEntity)
    .subscribe(
      paramWorksRatesReturn => {
  
      },
      (error: any) => {
        console.log(JSON.stringify(error));
      }
    );
  }
  addTaskReferenced(): void {
    if (this.workTasksContentInput === undefined) {
      this.workTasksContentInput = [];
    }
    // this.tasksrefToUpdate = undefined;
    this.parentTaskRef = {
      rootParam: undefined,
      parentParam: undefined,
      statutCall: 'modal',
      stdEntity: this._userService.getUserLogged().entity, 
      userlang: this._userService.getUserLogged().userlang
    };
    this.openTaskRefModal();
    // this.isOkToSave = true;
  }
  openTaskRefModal(): void {
    this.dataUpstream = {
      equipType: this.equipItem.equipType,
      equipBrand: this.equipItem.equipBrand,
      equipModel: this.equipItem.equipModel,
    };
    this.openModal(this.taskReferencedModal);
  }
  openModal(template: TemplateRef<any>) {

    // this.modalText = [docCur.docName];
    this.modalRef = this.modalService.show(template, this.configModal);
    // https://stackoverflow.com/questions/46408428/ngx-bootstrap-modal-how-to-get-a-return-value-from-a-modal
    /*
    this.modalRef.content.onClose.subscribe(result => {
      console.log('results', result);
    })
    */
  }
  // ========================================================== errors alerts 
messageBoxDisplay(_messageDisplay: MessageDisplay): void {

  const dialogConfig = new MatDialogConfig();
  const messageBox = this._translate.instant(_messageDisplay.messageLabel, _messageDisplay.messageArgs );
  
  // const messageDisplayCACHE = JSON.parse(JSON.stringify(_messageDisplay));
  dialogConfig.disableClose = true;
  dialogConfig.autoFocus = true;
  dialogConfig.data = {
    id: 1,
    title: this._translate.getTranslate( _messageDisplay.titleBox),
    typeDialog: _messageDisplay.typeDialog,
    panelClass: 'stdTheme',
    contentMessage: messageBox,
    data1: _messageDisplay.messageDatas,
    data2: '',
    actionCur: _messageDisplay.actionCur,
    progressDeterminate: _messageDisplay.progressDeterminate,
    errorsList: undefined,
    messageType: _messageDisplay.messageType
  };
  this.messageDialogRef = this._dialog.open(ModalCommonComponent, dialogConfig);
  
  this.messageDialogRef.afterClosed()
  .pipe(takeUntil(this.onDestroy))
  .subscribe(
    data => {
      // data: "okAction"
      if (data === 'okAction') {

      }
    });
  }
  closeMatDialog(): void {
    this._dialog.closeAll();

    // console.log(this._dialog.openDialogs.length);
    if (this._dialog.openDialogs.length > 0) {

      for (const instCur of this._dialog.openDialogs) {
        this._dialog.openDialogs.splice(0, 1);
      }
    }
    this.messageDialogRef = null;
  }
  private endProcessFile() {
    this.closeMatDialog();

  }
  closeModal() {
    if (this.modalRef !== undefined) {
      this.modalRef.hide();
    } 
  }
  displayMessage(_actionCur: string, messageContent?: string, _idxTask?: number) {

    const dialogConfig = new MatDialogConfig();
    let titleBox: string;
    let messageBox: string;

    if (_actionCur === 'removeTask') {
      messageBox = 'removeTask';
      titleBox = 'tasksBox';
    }
    if (_actionCur === 'duplicateTask') {
      messageBox = 'duplicateTask';
      titleBox = 'tasksBox';
    }
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      id: 1,
      title: this._translate.getTranslate(titleBox),
      typeDialog: 'confirmAction',
      typeDisplay: 'HTML',
      panelClass: 'stdTheme',
      contentMessage: (_actionCur === 'removeTask' || _actionCur === 'duplicateTask' ? messageContent : this._translate.getTranslate(messageBox) + ' --> ' + messageContent + ' ?') ,
      data1: '',
      data2: '',
      messageType: 'ERROR'

      };
 
    this.messageDialogRef = this._dialog.open(ModalCommonComponent, dialogConfig);
    
    this.messageDialogRef.afterClosed()
    .pipe(takeUntil(this.onDestroy))
    .subscribe(data => {
        // console.log('Dialog output:', data);
        if (data === 'okAction' && _actionCur === 'removeTask') {
          this.taskSelectedRemove(_idxTask);
          // this.displayMessage('waitingInvoicing');
        }
        if (data === 'okAction' && _actionCur === 'duplicateTask') {
          this.duplicateSelectedTask(_idxTask);
          // this.displayMessage('waitingInvoicing');
        }
       
      });

  }
}
